import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { AdvancedFilter } from '@kodit/core/shared-ui';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import { Store } from '@ngrx/store';
import {
  clearFilter,
  setFilter,
} from '../../../../../../../shared-subforms/src/lib/racun/state/filters/filter.actions';
import { StrankaMultiSelectItem } from '@kodit/core/data-api';

export interface IDatoObavestenjeFilter {
  dateFrom?: Date;
  dateTo?: Date;
  searchTerm?: string;
  stranke?: StrankaMultiSelectItem[];
}

@Component({
  selector: 'kodit-dato-obavestenje-filter',
  templateUrl: './dato-obavestenje-filter.component.html',
  styleUrls: ['./dato-obavestenje-filter.component.scss'],
})
export class DatoObavestenjeFilterComponent
  implements OnInit, AdvancedFilter<IDatoObavestenjeFilter>
{
  filterData!: IDatoObavestenjeFilter;
  form!: FormGroupTypeSafe<IDatoObavestenjeFilter>;

  @Output() onSubmitForm = new EventEmitter<IDatoObavestenjeFilter>();

  constructor(
    private _fb: FormBuilderTypeSafe,
    private _storage: Store
  ) {}

  ngOnInit(): void {
    this.form = this._buildForm(this.filterData);
  }

  onFilterSubmit() {
    this._storage.dispatch(
      setFilter({
        key: 'SEF|Dato',
        filter: JSON.stringify(this.form.value),
      })
    );
  }

  onFilterHide(shouldReset: boolean) {
    if (shouldReset) {
      this._storage.dispatch(clearFilter({ key: 'SEF|Dato' }));
    }
  }

  get strankeFormArray(): FormArray {
    return this.form.get('stranke') as FormArray;
  }

  private _buildForm(
    model: IDatoObavestenjeFilter
  ): FormGroupTypeSafe<IDatoObavestenjeFilter> {
    return this._fb.group<IDatoObavestenjeFilter>({
      dateFrom: new FormControl(model?.dateFrom ? new Date(model.dateFrom) : null),
      dateTo: new FormControl(model?.dateTo ? new Date(model.dateTo) : null),
      searchTerm: new FormControl(model?.searchTerm ?? null),
      stranke: new FormArray(model?.stranke?.map((s) => new FormControl(s)) ?? []),
    });
  }
}
